import { render, staticRenderFns } from "./DetalhesAtoInfralegal.vue?vue&type=template&id=dd8e62ea&scoped=true"
import script from "./DetalhesAtoInfralegal.vue?vue&type=script&lang=js"
export * from "./DetalhesAtoInfralegal.vue?vue&type=script&lang=js"
import style0 from "./DetalhesAtoInfralegal.vue?vue&type=style&index=0&id=dd8e62ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8e62ea",
  null
  
)

export default component.exports